import axios from 'axios';
import { i18n } from 'vue-lang-router';
import { TAGS_FOR_OIL_GAS_FINDER_RELATED_MATERIALS } from '../../config';

const apiUrl = process.env.VUE_APP_API_SUPPORT_URL;
const finderApiUrl = `${apiUrl}/oil-gas-finder`;
const tags = TAGS_FOR_OIL_GAS_FINDER_RELATED_MATERIALS;

export default {
  state: {
    brands: null,
    brandsLoading: false,
    models: null,
    modelsLoading: false,
    engines: null,
    enginesLoading: false,
    manufacturedDates: null,
    manufacturedDatesLoading: false,
    results: null,
    resultsLoading: false,
    tagsForRelatedMaterials: [],
    relatedMaterials: [],
    relatedMaterialsLoadingMore: false,
    relatedMaterialsCurrentPage: 1,
    relatedMaterialsTotalPages: null,
    relatedMaterialsReachedTheEnd: false,
  },
  getters: {
    brands: (state) => state.brands,
    brandsLoading: (state) => state.brandsLoading,
    models: (state) => state.models,
    modelsLoading: (state) => state.modelsLoading,
    engines: (state) => state.engines,
    enginesLoading: (state) => state.enginesLoading,
    manufacturedDates: (state) => state.manufacturedDates,
    manufacturedDatesLoading: (state) => state.manufacturedDatesLoading,
    results: (state) => state.results,
    resultsLoading: (state) => state.resultsLoading,
    tagsForRelatedMaterials: (state) => state.tagsForRelatedMaterials,
    relatedMaterials: (state) => state.relatedMaterials,
    relatedMaterialsLoadingMore: (state) => state.relatedMaterialsLoadingMore,
    relatedMaterialsReachedTheEnd: (state) => state.relatedMaterialsReachedTheEnd,
  },
  mutations: {
    getBrands: (state) => {
      state.brandsLoading = true;
      state.models = null;
      state.engines = null;
      state.manufacturedDates = null;
    },
    getBrandsSuccess: (state, payload) => {
      state.brandsLoading = false;
      state.brands = payload;
    },
    getBrandsFailure: (state) => {
      state.brandsLoading = false;
    },
    getModels: (state) => {
      state.modelsLoading = true;
      state.engines = null;
      state.manufacturedDates = null;
    },
    getModelsSuccess: (state, payload) => {
      state.modelsLoading = false;
      state.models = payload;
    },
    getModelsFailure: (state) => {
      state.modelsLoading = false;
    },
    getEngines: (state) => {
      state.enginesLoading = true;
      state.manufacturedDates = null;
    },
    getEnginesSuccess: (state, payload) => {
      state.enginesLoading = false;
      state.engines = payload;
    },
    getEnginesFailure: (state) => {
      state.enginesLoading = false;
    },
    getManufacturedDates: (state) => {
      state.manufacturedDatesLoading = true;
    },
    getManufacturedDatesSuccess: (state, payload) => {
      state.manufacturedDatesLoading = false;
      state.manufacturedDates = payload;
    },
    getManufacturedDatesFailure: (state) => {
      state.manufacturedDatesLoading = false;
    },
    getResults: (state) => {
      state.resultsLoading = true;
    },
    getResultsSuccess: (state, payload) => {
      state.results = payload;
      state.resultsLoading = false;
    },
    getResultsFailure: (state) => {
      state.resultsLoading = false;
    },
    reset: (state) => {
      state.models = null;
      state.engines = null;
      state.manufacturedDates = null;
    },
    getTags: (state, payload) => {
      state.tagsForRelatedMaterials = payload;
    },
    getRelatedMaterials: (state, payload) => {
      state.relatedMaterialsLoadingMore = payload.loadingMore;
      if (state.relatedMaterialsLoadingMore) {
        state.relatedMaterialsCurrentPage += 1;
      } else {
        state.relatedMaterials = [];
        state.relatedMaterialsCurrentPage = 1;
      }
    },
    getRelatedMaterialsSuccess: (state, payload) => {
      if (state.relatedMaterialsLoadingMore) {
        state.relatedMaterials = state.relatedMaterials.concat(payload.data);
      } else {
        state.relatedMaterials = payload.data;
        state.relatedMaterialsTotalPages = Number(payload.headers['x-wp-totalpages']);
      }
      state.relatedMaterialsReachedTheEnd = state.relatedMaterialsCurrentPage >= state.relatedMaterialsTotalPages;
      state.relatedMaterialsLoadingMore = false;
    },
    getRelatedMaterialsFailure: (state) => {
      state.relatedMaterialsLoadingMore = false;
      state.relatedMaterials = [];
    },
  },
  actions: {
    GET_BRANDS: ({ commit }) => {
      commit('getBrands');
      return new Promise((resolve, reject) => {
        axios.get(`${finderApiUrl}/makes`).then((response) => {
          resolve();
          commit('getBrandsSuccess', response.data);
        }).catch(() => {
          reject();
          commit('getBrandsFailure');
        });
      });
    },
    GET_MODELS: ({ commit }, payload) => {
      commit('getModels');
      const params = {
        make: payload,
      };
      return new Promise((resolve, reject) => {
        axios.get(`${finderApiUrl}/models`, { params }).then((response) => {
          resolve();
          commit('getModelsSuccess', response.data);
        }).catch(() => {
          reject();
          commit('getModelsFailure');
        });
      });
    },
    GET_ENGINES: ({ commit }, payload) => {
      commit('getEngines');
      const params = {
        model: payload,
      };
      return new Promise((resolve, reject) => {
        axios.get(`${finderApiUrl}/engines`, { params }).then((response) => {
          resolve();
          commit('getEnginesSuccess', response.data);
        }).catch(() => {
          reject();
          commit('getEnginesFailure');
        });
      });
    },
    GET_MANUFACTURED_DATES: ({ commit }, payload) => {
      commit('getManufacturedDates');
      const params = {
        model: payload.model,
        engine: payload.engine,
      };
      return new Promise((resolve, reject) => {
        axios.get(`${finderApiUrl}/manufactured-from`, { params }).then((response) => {
          resolve();
          commit('getManufacturedDatesSuccess', response.data);
        }).catch(() => {
          reject();
          commit('getManufacturedDatesFailure');
        });
      });
    },
    GET_RESULTS: ({ commit }, payload) => {
      commit('getResults');
      return new Promise((resolve, reject) => {
        axios.get(`${finderApiUrl}/search`, { params: payload }).then((response) => {
          resolve();
          commit('getResultsSuccess', response.data);
        }).catch(() => {
          reject();
          commit('getResultsFailure');
        });
      });
    },
    GET_ONE: ({}, payload) => {
      return new Promise((resolve, reject) => {
        axios.get(`${finderApiUrl}/${payload}`).then((response) => {
          resolve(response.data);
        }).catch(() => {
          reject();
        });
      });
    },
    SEND_EMAIL: ({}, payload) => {
      const params = {
        oil_id: payload.oilId,
        email: payload.email,
      };
      return new Promise((resolve, reject) => {
        axios.post(`${finderApiUrl}/send`, { ...params }).then((response) => {
          resolve(response.data);
        }).catch(() => {
          reject();
        });
      });
    },
    RESET: ({ commit }) => {
      commit('reset');
    },
    GET_TAGS: async ({ commit }) => {
      // Have to do multiple queries to retrieve ID of each tag
      const endpoints = tags.map((tag) => {
        return `${process.env.VUE_APP_API_URL}/tags?search=${tag}&lang=${i18n.locale}`;
      });
      const tagsIds = await axios.all(endpoints.map((endpoint) => axios.get(endpoint))).then((responses) => {
        const ids = [];
        responses.forEach((response) => {
          if (response?.data[0]?.id) {
            ids.push(response.data[0].id);
          }
        });
        return ids;
      });
      if (tagsIds.length) {
        commit('getTags', tagsIds);
      }
      return tagsIds;
    },
    GET_RELATED_MATERIALS: ({ commit, state }, payload) => {
      if (state.tagsForRelatedMaterials) {
        const { loadingMore } = payload;
        commit('getRelatedMaterials', { loadingMore });
        const paginationParams = {
          page: state.relatedMaterialsCurrentPage,
          per_page: 5,
        };
        const params = {
          tags: state.tagsForRelatedMaterials.join(),
          lang: i18n.locale,
          ...paginationParams,
        };
        return new Promise((resolve, reject) => {
          axios.get(`${process.env.VUE_APP_API_URL}/materials`, { params }).then((response) => {
            commit('getRelatedMaterialsSuccess', response);
            resolve();
          }).catch(() => {
            reject();
            commit('getRelatedMaterialsFailure');
          });
        });
      }
      return false;
    },
  },
  namespaced: true,
};
